import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_10 = { class: "min-w-250px" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("a", { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }, "   ED PLAN MATCH", -1)
const _hoisted_14 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted font-weight-bold d-block"
}
const _hoisted_18 = {
  key: 1,
  class: "text-muted font-weight-bold d-block"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_21 = {
  key: 0,
  class: "text-muted font-weight-bold d-block"
}
const _hoisted_22 = {
  key: 1,
  class: "text-muted font-weight-bold d-block"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_25 = { class: "card-body d-flex flex-column" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "flex-grow-1" }
const _hoisted_28 = { class: "pt-5" }
const _hoisted_29 = { class: "text-center fs-6 pb-5 " }
const _hoisted_30 = { class: "badge badge-light-primary fs-8" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        (_ctx.pt != 'ovi')
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_ECP_EDP_DashboardNavigator)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("table", _hoisted_8, [
                  _createVNode("thead", null, [
                    _createVNode("tr", _hoisted_9, [
                      _createVNode("th", _hoisted_10, "   Account Info - " + _toDisplayString(_ctx.user.usid), 1)
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_ctx.pt == 'edp')
                      ? (_openBlock(), _createBlock("tr", _hoisted_11, [
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_12, [
                              _createVNode("div", null, [
                                _hoisted_13,
                                _createVNode("span", _hoisted_14, "   " + _toDisplayString(_ctx.edplanpairs) + "  /  " + _toDisplayString(_ctx.maxUturn), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary1, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", null, [
                              _createVNode("a", _hoisted_16, "   " + _toDisplayString(item.tdesc.toUpperCase()), 1),
                              (item.vAmt.match('^[1-9]\\\d*(\\\.\\\d+)?$'))
                                ? (_openBlock(), _createBlock("span", _hoisted_17, "   " + _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                                : (_openBlock(), _createBlock("span", _hoisted_18, "   " + _toDisplayString(item.vAmt), 1))
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary2, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", null, [
                              _createVNode("a", _hoisted_20, "   " + _toDisplayString(item.tdesc.toUpperCase()), 1),
                              (item.vAmt.match('^[1-9]\\\d*(\\\.\\\d+)?$'))
                                ? (_openBlock(), _createBlock("span", _hoisted_21, "   " + _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                                : (_openBlock(), _createBlock("span", _hoisted_22, "   " + _toDisplayString(item.vAmt), 1))
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.isShowMore == true && _ctx.ccode != 15)
                      ? (_openBlock(), _createBlock("tr", _hoisted_23, [
                          _createVNode("td", null, [
                            _createVNode("button", {
                              class: "btn btn-success btn-sm",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreAccountInfo()))
                            }, "Show More")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.ccode == 0 && _ctx.packageType != 'REGV4Z01')
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createVNode("div", _hoisted_27, [
                          _createVNode(_component_apexchart, {
                            class: "mixed-widget-4-chart",
                            options: _ctx.chartOptions,
                            series: _ctx.series,
                            height: "500",
                            type: "radialBar"
                          }, null, 8, ["options", "series"])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("p", _hoisted_29, [
                        _createVNode("span", _hoisted_30, "You have PhP" + _toDisplayString(_ctx.numberWithCommas(_ctx.carfundMonitor.car_fund.toFixed(2))) + " in your car fund.", 1),
                        _hoisted_31
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}